import { useEffect, useState } from "react";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { config } from "@/config";
import type { User } from "@repo/types";
import { useUserStore } from "@/stores/userStore";
import { stripePromise } from "@/services/stripeService";
import { useSearchParams } from "react-router-dom";

const CheckOut = ({ user }: { user: User }) => {
  const [clientSecret, setClientSecret] = useState("");
  const [searchParams] = useSearchParams();

  const { email } = user;

  useEffect(() => {
    let canceled = false;

    // Create a Checkout Session as soon as the page loads
    fetch(
      `${config.urls.api}/v1/payment/session?${new URLSearchParams({
        customerEmail: email,
        productId:
          searchParams.get("subscriptionType") ??
          "price_1OrOtwFZGtqqYcBzZcIblJm7",
        discountCode: searchParams.get("discountCode") ?? "",
        returnUrl: window.location.href.replace(
          /\bstepId=\d+/,
          `stepId=${parseInt(searchParams.get("stepId") ?? "0") + 1}`
        ),
      })}`,
      {
        method: "POST",
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (!canceled) setClientSecret(data.clientSecret);
      });

    return () => {
      canceled = true;
    };
  }, [email, searchParams]);

  return (
    <div id="checkout">
      {clientSecret && (
        <EmbeddedCheckoutProvider
          stripe={stripePromise}
          options={{ clientSecret }}
        >
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      )}
      <div className="pt-16 w-full">
        <p>
          CiviLink partners with Stripe to provide easy checkout and
          subscription management. To pay by check, continue checking out, and
          contact CiviLink at{" "}
          <a href="mailto:contact@civi.link" className="underline">
            contact@civi.link
          </a>{" "}
          later for invoicing and payment options.
        </p>
      </div>
    </div>
  );
};

export const CheckOutStep = () => {
  const { user } = useUserStore();
  if (!user) return null;
  return <CheckOut user={user} />;
};
